import api from './api';

/**
 * Add item to user's cart (admin only)
 * @param {Object} cartItem - Cart item data with specifications
 * @param {string} userIdentifier - Username or phone number (exact match)
 * @returns {Promise<Object>} Response with cart ID and user info
 */
export const addItemToUserCart = async (cartItem, userIdentifier) => {
  const response = await api.post('/admin/cart/manual-add/', {
    cartItem,
    user_identifier: userIdentifier,
  });
  return response.data;
};

/**
 * Get list of admin-added cart items
 * @param {Object} params - Query parameters
 * @param {string} params.user - Optional user identifier (username or phone) to filter by
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.page_size - Items per page (default: 20, max: 100)
 * @returns {Promise<Object>} Response with cart items
 */
export const getAdminCartItems = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.user) queryParams.append('user', params.user);
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  
  const url = `/admin/cart/list${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const response = await api.get(url);
  return response.data;
};

export const updateAdminCartSkuQuantity = async (skuId, quantity) => {
  const response = await api.patch(`/admin/cart/skus/${skuId}/quantity/`, { quantity });
  return response.data;
};

export const deleteAdminCartItem = async (cartId) => {
  const response = await api.delete(`/admin/cart/items/${cartId}/`);
  return response.data;
};

/**
 * Fetch item details from OneBound API (admin only)
 * Fetches directly from API, translates title, and starts async translation for props/skus
 * @param {string} num_iid - Item number (1688 offer ID)
 * @returns {Promise<Object>} Item details with translated title and translation task ID
 */
export const fetchItemDetails = async (num_iid) => {
  const response = await api.post('/admin/cart/fetch-item/', {
    num_iid: num_iid,
  });
  return response.data;
};

/**
 * Check translation status for props and skus_props_list
 * @param {string} taskId - Celery task ID
 * @returns {Promise<Object>} Translation status and results
 */
export const checkTranslationStatus = async (taskId) => {
  const response = await api.get(`/admin/cart/translation-status/${taskId}/`);
  return response.data;
};

const cartService = {
  addItemToUserCart,
  getAdminCartItems,
  updateAdminCartSkuQuantity,
  deleteAdminCartItem,
  fetchItemDetails,
};

export default cartService;
